module.exports = {"321371050":"黄河街道","321371052":"三棵树街道","321371351":"南蔡乡","321371400":"古楚街道办"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321371.json
// module id = 1040
// module chunks = 0